var _path, _circle, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChefLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 67 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3098 0C14.9431 0 0 14.9431 0 33.3098C0 38.8234 1.37851 44.2903 3.99912 49.1392L31.4882 98.8556C31.8542 99.5185 32.5515 99.9291 33.3098 99.9291C34.068 99.9291 34.7654 99.5185 35.1313 98.8556L62.6306 49.1228C65.241 44.2903 66.6195 38.8232 66.6195 33.3096C66.6195 14.9431 51.6764 0 33.3098 0ZM33.3098 49.9646C24.1264 49.9646 16.655 42.4931 16.655 33.3098C16.655 24.1264 24.1264 16.655 33.3098 16.655C42.4931 16.655 49.9646 24.1264 49.9646 33.3098C49.9646 42.4931 42.4931 49.9646 33.3098 49.9646Z",
    fill: "#D9622A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 35,
    r: 26.5,
    fill: "white",
    stroke: "#D9622A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6963 19.9226C27.8876 18.8201 29.9678 18.6578 30.3438 19.6965C29.4569 19.5478 28.5478 19.6259 27.6963 19.9226Z",
    fill: "#D9622A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8219 43.6736C40.0913 44.804 41.8632 48.62 34.6388 47.9133C30.617 47.4444 26.9226 45.4011 24.3153 42.2032C32.7985 41.673 40.2286 37.6878 46.625 38.6695C49.5051 40.7897 52.5153 42.7755 54 44.0471C53.1035 43.6736 51.2015 43.1787 47.8219 43.6736Z",
    fill: "#D9622A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2976 37.3913C40.9276 34.2534 39.4435 25.8372 33.9699 21.7598C36.9394 22.4665 40.5516 23.9784 42.6515 27.102C45.0117 30.5576 45.853 35.2711 46.1133 37.1931C44.5056 37.0822 42.8914 37.1485 41.2976 37.3913Z",
    fill: "#D9622A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.469 40.6845C23.8476 40.861 22.5068 40.8331 20.3517 41.0165C18.2991 41.193 17.5537 41.4686 16.9307 41.0803C16.5631 40.8059 16.3287 40.381 16.2879 39.914C16.0636 38.6418 15.9695 37.3485 16.0073 36.0558C16.0073 29.18 19.4282 24.2825 26.2695 21.8303C22.1716 27.0741 24.4634 37.1013 25.469 40.6845Z",
    fill: "#D9622A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9414 37.5677C37.1363 38.0837 32.0873 39.6879 26.847 40.5073C25.9578 37.3627 22.872 24.791 29.221 21.0951C37.5674 22.8269 39.5307 33.9852 39.9414 37.5677Z",
    fill: "#D9622A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefLocation);
export default __webpack_public_path__ + "static/media/Chef-location.e7b1a2523a2ae99481232685cbd691d9.svg";
export { ForwardRef as ReactComponent };